import type { Tenant } from '../../types/lac';

export const DESCRIPTION_MAX_LENGTH = 2000;

export function initialDisplayName(tenant: Tenant): string {
  return tenant.displayName?.trim() || tenant.name;
}

export function initialDescription(tenant: Tenant): string {
  return tenant.description ?? '';
}

export function initialMaxUsers(tenant: Tenant): string {
  return tenant.maxUsers != null ? String(tenant.maxUsers) : '';
}
